'use strict';

function AddCashReturnController (
    $scope,
    $mdDialog,
    cashboxes,
    defaultCashbox
) {
    'ngInject';

    $scope.btnDisabled = true;
    $scope.cashboxes = cashboxes;
    $scope.cashbox = defaultCashbox;

    $scope.save = function() {
        if ($scope.form.$valid) {
            $mdDialog.hide({
                comments: $scope.comments,
                amount: $scope.amount,
                dstCashboxId: $scope.cashbox.id
            });
        }
    };

    $scope.cancel = function() {
        $mdDialog.cancel();
    };
}

export default AddCashReturnController;
